import { fork } from 'redux-saga/effects'

import authSaga from './Authorization'
import reviewsSaga from './Reviews'
import campaignSaga from './Campaigns'
import eventDetails from './eventDetails'

function* rootSaga() {
  yield fork(authSaga)
  yield fork(reviewsSaga)
  yield fork(campaignSaga)
  yield fork(eventDetails)
}

export default ({ run }) => {
  run(rootSaga)
}
